// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3412":"322ec021","9404":"4c283bf7"}[chunkId] + ".chunk.css";
};